export function templateParser(template, variables = {}) {
    const snippet = TemplateSnippet(template);
    return snippet(variables);
}

const TemplateSnippet = function (template) {
    'use strict';
    const re = /\{\{(.+?)\}\}/g;
    let snippet = 'var snippet=[];\n', cursor = 0, match;
    const add = function (line, js) {
        if (line.indexOf('|') !== -1) {
            snippet += 'if (this.' + line.split('|')[1].trim() + ') {';
            add(line.split('|')[0], js);
            snippet += '}';
            return;
        }
        line = line.replace(/([$][a-zA-Z0-9-_]+)/g, `' + this.$1 + '`)
        if (line !== '') {
            if (js) {
                snippet += 'snippet.push(' + line + ');\n'
            } else {
                snippet += 'snippet.push(`' + line.replace('\'', '') + '`);\n';
            }
        }
    };
    while (match = re.exec(template)) {
        add(template.slice(cursor, match.index));
        add(match[1], true);
        cursor = match.index + match[0].length;
    }
    add(template.substr(cursor, template.length - cursor));
    snippet += 'return snippet.join(\'\');';
    const preprocessor = new Function(snippet.replace(/[\r\t\n]/g, ' '));
    const templateFunction = function (data) {
        try {
            return preprocessor.call(data);
        } catch (err) {
            const error = new Error('TemplateSnippetError(' + err.name + '): ' + err.message);
            error.snippet = snippet;
            throw error;
        }
    };
    templateFunction.getTemplate = function () {
        return template;
    };
    templateFunction.getSnippet = function () {
        return snippet;
    };
    return templateFunction;
};



// WEBPACK FOOTER //
// ./src/plugins/template.plugin.js